<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { dynamicTime } from 'shared/helpers/timeHelper';

import ContactInformationSection from 'dashboard/components-next/Contacts/Pages/ContactInformationSection.vue';
import EditContactDetailsDialog from 'dashboard/components-next/Contacts/Pages/EditContactDetailsDialog.vue';

const props = defineProps({
  selectedContact: {
    type: Object,
    required: true,
  },
});

const editContactDetailsDialogRef = ref(null);
const { locale } = useI18n();

const createdAt = computed(() => {
  return props.selectedContact?.createdAt
    ? dynamicTime(props.selectedContact.createdAt, locale.value)
    : '';
});

const lastActivityAt = computed(() => {
  return props.selectedContact?.lastActivityAt
    ? dynamicTime(props.selectedContact.lastActivityAt, locale.value)
    : '';
});

const openEditContactDialog = () => {
  editContactDetailsDialogRef.value?.open();
};

defineExpose({ openEditContactDialog });
</script>

<template>
  <div class="flex flex-col items-start w-full">
    <ContactInformationSection
      :selected-contact="selectedContact"
      :created-at="createdAt"
      :last-activity-at="lastActivityAt"
      @edit="openEditContactDialog"
    />
    <EditContactDetailsDialog
      ref="editContactDetailsDialogRef"
      :selected-contact="selectedContact"
    />
  </div>
</template>
